module.exports = {
  languages: [{
    "id": 1,
    "description": "English",
    "cod": "en",
    "COD": "ENG",
    "icon": "/static/img/flags/en.png",
    "default": true
  },
  {
    "id": 2,
    "description": "Italiano",
    "cod": "it",
    "COD": "ITA",
    "icon": "/static/img/flags/it.png",
    "default": false
  },
  {
    "id": 3,
    "description": "Deutsch",
    "cod": "de",
    "COD": "TED",
    "icon": "/static/img/flags/de.png",
    "default": false
  },
  {
    "id": 4,
    "description": "Français",
    "cod": "fr",
    "COD": "FRA",
    "icon": "/static/img/flags/fr.png",
    "default": false
  },
  {
    "id": 5,
    "description": "Español",
    "cod": "es",
    "COD": "SPA",
    "icon": "/static/img/flags/es.png",
    "default": false
  }
  ],

  translations: [{
    "id": 1,
    "lang": "en",
    "sel": "Select language: ",
    "forgotpwd": "Reset password",
    "btnCancel": "Cancel",
    "btnOk":"Ok",
    "btn": "Go in",
    "brosMsg": "The browser you are using is not supported",
    "curBro": "Current browser:",
    "supBro": "Supported browsers:",
    "over": "or higher",
    "resPwd": "Please enter your e-mail address",
    "setPwd": "Password setting",
    "pwdCompliance": "The password must be at least 8 characters, it must contain at least one capital letter, one lowercase letter, a number and a character which is neither letter nor number (underscore excluded).",
    "istrPwd": "We will send you an e-mail with the link to reset your password",
    "err": "Invalid Username and/or Password",
    "errEmailFormat": "Please enter a valid e-mail address",
    "errEmailExist": "Unknown e-mail address",
    "headRes": "Done!",
    "descRes": "We have sent you an e-mail with the link to reset your password",
    "newPwd": "enter your new password",
    "confPwd": "enter the new password again",
    "pwdErr": "The fields are not matching or empty",
    "pleaseWait": "Please wait...",
    "buildReg": "Preparing your data...",
    "welcome": "Welcome! Data preparation has started and it may take a few minutes.",
    "welcome2": "Welcome! Data preparation has already started and it may take a few minutes.",
    "errTimeout": "Data preparation has exceeded the time limit: please try again in a few minutes.",
    "retry": "The server is busy. Please try again in a few minutes (estimated time: ",
    "min": "minutes",
    "errChangePwd": "Your password has expired. Pleas Click on \"Reset Password\"",
    "errOverIdle": "Your account has been inactive for too long and it must be verified: if the outcome of the verification is positive, you will receive an e-mail to reset the password within 2 working days.",
    "errLogin": "Wrong request parameters or unexpected error",
    "errCredentials": "Wrong credentials. If you don't remember the password, click on \"Reset Password\" to change it.",
    "errNotAuth": "Unauthorized request",
    "errImpoRes":"Impossible to reset the password because user verification, due to prolonged inactivity, is in progress: if the outcome of verification is positive you will receive an e-mail to reset the password within 2 working days.",
    "errNotHandled":"Unable to reset the password of users of direct customers and distributors as they are not managed by this system",
    "errUnexpected":"Unexpected error",
    "errCodNotFound":"Password reset code not found or expired",
    "errPwdForm":"The new password is not compliant",
    "pwdChanged":"The new password has been set successfully",
    "errServer":"It's not possible to complete the requested operation, try again later",
    "goToLoginBtn":"Login"
  },
  {
    "id": 2,
    "lang": "it",
    "sel": "Seleziona lingua: ",
    "forgotpwd": "Reimposta password",
    "btnCancel": "Annulla",
    "btnOk":"Ok",
    "btn": "Entra",
    "brosMsg": "Il browser in uso non è supportato",
    "curBro": "Browser corrente:",
    "supBro": "Browser supportati:",
    "over": "o superiore",
    "resPwd": "Inserisci il tuo indirizzo e-mail",
    "setPwd": "Impostazione password",
    "pwdCompliance": "La password deve essere almeno di 8 caratteri, deve contenere almeno una lettera maiuscola, una minuscola, un numero e un carattere che non sia ne lettera ne numero (trattino basso escluso).",
    "istrPwd": "Ti invieremo una e-mail con il link per reimpostare la password",
    "err": "Utente e/o Password non validi",
    "errEmailFormat": "Si prega di inserire un indirizzo e-mail valido",
    "errEmailExist": "Indirizzo e-mail inesistente",
    "headRes": "Fatto!",
    "descRes": "Ti abbiamo inviato una e-mail con il link per reimpostare la password",
    "newPwd": "inserisci la nuova password",
    "confPwd": "reinserisci la nuova password",
    "pwdErr": "I campi non corrispondono o sono vuoti",
    "pleaseWait": "Attendere prego",
    "buildReg": "creazione del registry...",
    "welcome": "Benvenuto. Stiamo installando i tuoi dati. Ci vorrà qualche minuto",
    "welcome2": "Benvenuto. Stiamo già installando i tuoi dati. Ci vorrà qualche minuto",
    "errTimeout": "L'installazione dei dati ha superato il limite di tempo previsto",
    "retry": "Le risorse sul server sono temporaneamente già impegnate, riprovare più tardi (tempo stimato: ",
    "min": "minuti",
    "errChangePwd": "La password è scaduta. Clicca su \"Reimposta Password\"",
    "errOverIdle": "L'account è inattivo da troppo tempo e necessita di una approvazione. Chiedi un reset all'amministratore",
    "errLogin": "Parametri della richiesta errati o errore inatteso",
    "errCredentials": "Credenziali errate. Se non ricordi la password, clicca su \"Reimposta Password\" per cambiarla.",
    "errNotAuth": "Richiesta non autorizzata",
    "errImpoRes":"Impossibile resettare, reset già effettuato causa inutilizzo (account in fase di validazione)",
    "errNotHandled":"Impossibile resettare gli utenti dei clienti diretti e dei distributori in quanto non sono gestiti da APS",
    "errUnexpected":"Errore inatteso",
    "errCodNotFound":"codice reset non trovato o scaduto",
    "errPwdForm":"nuova password non conforme",
    "pwdChanged":"La nuova password è stata impostata correttamente.",
    "errServer":"Impossibile effettuare l'operazione richiesta, riprovare più tardi",
    "goToLoginBtn":"Login"
  },
  {
    "id": 3,
    "lang": "de",
    "sel": "Sprache auswählen: ",
    "forgotpwd": "Passwort zurücksetzen",
    "btnCancel": "Annullieren",
    "btnOk":"Ok",
    "btn": "Anmelden",
    "brosMsg": "Der von Ihnen verwendete Browser wird nicht unterstützt.",
    "curBro": "Aktueller Browser:",
    "supBro": "Unterstütze Browsers:",
    "over": "oder höher",
    "resPwd": "Geben Sie Ihre E-Mail-Adresse ein",
    "setPwd": "Passwort-Einstellung",
    "pwdCompliance": "Das Passwort muss mindestens 8 Zeichen lang sein, es muss mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein anderes Zeichen als einen Buchstaben oder eine Zahl enthalten (mit Ausnahme des Unterstrichs).",
    "istrPwd": "Wir werden Ihnen eine E-Mail mit dem Link zum Zurücksetzen Ihres Passworts schicken.",
    "err": "Ungültiger Benutzer oder Passwort",
    "errEmailFormat": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "errEmailExist": "E-Mail-Adresse unbekannt",
    "headRes": "Fertig!",
    "descRes": "Wir haben Ihnen eine E-Mail mit dem Link zum Zurücksetzen Ihres Passworts geschickt.",
    "newPwd": "geben Sie Ihr neues Passwort ein",
    "confPwd": "geben Sie Ihr neues Passwort erneut ein",
    "pwdErr": "Die für das Kennwort eingegebenen Werte stimmen nicht überein oder sind nicht eingegeben worden",
    "pleaseWait": "Bitte warten...",
    "buildReg": "Vorbereitung Ihrer Daten...",
    "welcome": "Willkommen! Die Vorbereitung Ihrer Daten hat begonnen und kann einige Minuten dauern.",
    "welcome2": "Willkommen! Die Vorbereitung Ihrer Daten ist im Gange und kann einige Minuten dauern.",
    "errTimeout": "Ihre Datenvorbereitung hat das Zeitlimit überschritten, versuchen Sie es in ein paar Minuten noch einmal.",
    "retry": "Der Server ist sehr beschäftigt, versuchen Sie es in ein paar Minuten erneut (geschätzte Zeit: ",
    "min": "Minuten",
    "errChangePwd": "Das Passwort ist abgelaufen. Klicken Sie auf \"Passwort zurücksetzen\"",
    "errOverIdle": "Der Benutzer war zu lange inaktiv und muss überprüft werden. Wenn das Ergebnis der Überprüfung positiv ist, erhalten Sie innerhalb von 2 Arbeitstagen eine E-Mail, um das Passwort zurückzusetzen.",
    "errLogin": "Falsche Anfrageparameter oder unerwarteter Fehler",
    "errCredentials": "Falsche Anmeldedaten. Wenn Sie sich nicht mehr an das Passwort erinnern, klicken Sie auf \"Passwort zurücksetzen\", um es zu ändern.",
    "errNotAuth": "Anfrage nicht autorisiert",
    "errImpoRes":"Es ist nicht möglich, das Passwort zurückzusetzen, die Benutzerüberprüfung ist wegen längerer Inaktivität des Systems im Gange. Wenn das Ergebnis der Überprüfung positiv ist, erhalten Sie innerhalb von 2 Arbeitstagen eine E-Mail, um das Passwort zurückzusetzen.",
    "errNotHandled":"Es ist nicht möglich, das Passwort von Direktkunden-Benutzern und Händlern zurückzusetzen, da sie nicht von diesem System verwaltet werden.",
    "errUnexpected":"Unerwarteter Fehler",
    "errCodNotFound":"unbekannter oder abgelaufener Passwort-Reset-Code",
    "errPwdForm":"neues Passwort nicht konform",
    "pwdChanged":"Das neue Passwort wurde eingestellt.",
    "errServer":"Die erforderliche Operation kann nicht durchgeführt werden, versuchen Sie es später noch einmal",
    "goToLoginBtn":"Anmelden"
  },
  {
    "id": 4,
    "lang": "fr",
    "sel": "Sélectionnez la langue: ",
    "forgotpwd": "Réinitialiser le mot de passe",
    "btnCancel": "Annuller",
    "btnOk":"Ok",
    "btn": "Entrez",
    "brosMsg": "Le navigateur que vous utilisez n’est pas supportés",
    "curBro": "Navigateur actuel:",
    "supBro": "Navigateur supportés:",
    "over": "ou supérieure",
    "resPwd": "Entrez votre adresse e-mail",
    "setPwd": "Paramètres du mot de passe",
    "pwdCompliance": "Le mot de passe doit être d’au moins 8 caractères, doit contenir au moins une lettre majuscule, une minuscule, un nombre et un caractère qui ne soit ni lettre ni nombre (tiret bas exclu)." ,
    "istrPwd": "Nous vous enverrons un mail avec le lien pour réinitialiser votre mot de passe",
    "err": "Utilisateur et/ou Mot de passe invalide",
    "errEmailFormat": "S’il vous plaît entrer une adresse e-mail valide",
    "errEmailExist": "Adresse e-mail inconnue",
    "headRes": "C’est fait!",
    "descRes": "Nous vous avons envoyé un e-mail avec le lien pour réinitialiser votre mot de passe.",
    "newPwd": "entrer le nouveau mot de passe",
    "confPwd": "réinsérer le nouveau mot de passe",
    "pwdErr": "Les valeurs saisies pour le mot de passe ne correspondent pas ou n’ont pas été saisis",
    "pleaseWait": "Veuillez patienter s’il vous plaît...",
    "buildReg": "Préparation de vos données...",
    "welcome": "La préparation de vos données a dépassé le temps imparti, réessayez dans quelques minutes.",
    "welcome2": "Bienvenue! La préparation de vos données est en cours et peut prendre quelques minutes.",
    "errTimeout": "La préparation de vos données a dépassé le temps imparti, réessayez dans quelques minutes.",
    "retry": "Le serveur est très occupé, réessayez dans quelques minutes (temps estimé: ",
    "min": "minutes",
    "errChangePwd": "Le mot de passe a expiré. Cliquez sur  \"Réinitialiser le mot de passe\"",
    "errOverIdle": "L’utilisateur est inactif depuis trop longtemps et doit être vérifié : si le résultat de la vérification est positif, vous recevrez un e-mail pour réinitialiser le mot de passe dans les 2 jours ouvrables.",
    "errLogin": "Mauvais paramètres de la demande ou erreur inattendue",
    "errCredentials": "Identifiants incorrects. Si vous ne vous souvenez pas du mot de passe, cliquez sur \"Réinitialiser le mot de passe\" pour le modifier.",
    "errNotAuth": "Demande non autorisée",
    "errImpoRes":"Impossible de réinitialiser le mot de passe, la vérification de l’utilisateur est en cours en raison de l’inutilité prolongée du système : si le résultat de la vérification est positif, vous recevrez un e-mail pour réinitialiser le mot de passe dans les 2 jours ouvrables.",
    "errNotHandled":"Impossible de réinitialiser le mot de passe des clients directs et des distributeurs car ils ne sont pas gérés par ce système",
    "errUnexpected":"Erreur inattendue",
    "errCodNotFound":"Mot de passe inconnu ou expiré",
    "errPwdForm":"nouveau mot de passe non conforme",
    "pwdChanged":"Le nouveau mot de passe a été défini.",
    "errServer":"Impossible d’effectuer l’opération demandée, réessayez plus tard",
    "goToLoginBtn":"Login"
  },
  {
    "id": 5,
    "lang": "es",
    "sel": "Selecciona tu idioma: ",
    "forgotpwd": "Restablecer contraseña",
    "btnCancel": "Cancelar",
    "btnOk":"Ok",
    "btn": "Entrar",
    "brosMsg": "El browser que está utilizando no es compatible",
    "curBro": "Browser corriente:",
    "supBro": "Browser compatibles:",
    "over": "o superior",
    "resPwd": "introduzca su dirección de correo electrónico",
    "setPwd": "Configuración de contraseña",
    "pwdCompliance": "La contraseña debe tener al menos 8 caracteres, debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter que no sea ni una letra ni un número (excluyendo el guión bajo).",
    "istrPwd": "Le enviaremos un correo electrónico con el enlace para restablecer su contraseña.",
    "err": "Usuario y / o contraseña inválidos",
    "errEmailFormat": "Por favor introduzca una dirección de correo electrónico válida",
    "errEmailExist": "Dirección de correo electrónico desconocida",
    "headRes": "hecho!",
    "descRes": "Le hemos enviado un correo electrónico con el enlace para restablecer su contraseña.",
    "newPwd": "Introduzca la nueva contraseña",
    "confPwd": "vuelva a ingresar la nueva contraseña",
    "pwdErr": "Los valores ingresados para la contraseña no coinciden o no se han ingresado",
    "pleaseWait": "Espere por favor...",
    "buildReg": "Preparación de sus datos...",
    "welcome": "Bienvenido! La preparación de sus datos ha comenzado y podría necesitar unos minutos..",
    "welcome2": "Bienvenido! La preparación de sus datos está en marcha y podría necesitar unos minutos..",
    "errTimeout": "Su preparación de datos ha excedido el límite de tiempo previsto, intente nuevamente en unos minutos.",
    "retry": "El server está muy ocupado, intente nuevamente en unos minutos (tiempo estimado: ",
    "min": "minutos",
    "errChangePwd": "La contraseña ha caducado. Haga clic en \"Restablecer contraseña\"",
    "errOverIdle": "El usuario ha estado inactivo durante demasiado tiempo y debe ser verificado: si el resultado de la verificación es positivo, recibirá un correo electrónico para restablecer la contraseña dentro de 2 días hábiles.",
    "errLogin": "Parámetros de solicitud incorrectos o error inesperado",
  "errCredentials": "Credenciales incorrectas. Si no recuerda la contraseña, haga clic en \"Restablecer contraseña\" para cambiarla.",
    "errNotAuth": "Solicitud no autorizada",
    "errImpoRes":" Imposible restablecer la contraseña, está en marcha la verificación del usuario debida a la inactividad prolongada del sistema: si el resultado de la verificación es positivo, recibirá un correo electrónico para restablecer la contraseña dentro de 2 días hábiles.",
    "errNotHandled":"Imposible restablecer la contraseña de los usuarios, de clientes directos y distribuidores, ya que no se gestionan por este sistema ",
    "errUnexpected":"Error inesperado",
    "errCodNotFound":"código de restablecimiento de contraseña desconocido o caducado",
    "errPwdForm":"nueva contraseña no compatible",
    "pwdChanged":"La nueva contraseña ha sido establecida.",
    "errServer":"Imposible realizar la operación solicitada, intente nuevamente más tarde",
    "goToLoginBtn":"Acceder"
  }]
}


//////////////////
// WEBPACK FOOTER
// ./static/js/lang_main.js
// module id = 1784
// module chunks = 1